export enum ForecastMethodEnum {
    synth = "synth",
    manual = "manual",
}
